import { render, staticRenderFns } from "./A11yTooltip.vue?vue&type=template&id=27c5e56e"
import script from "./A11yTooltip.vue?vue&type=script&lang=js"
export * from "./A11yTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports